import WebhookIntroduction from "./WebhookIntroduction";
import WebhookConfig from "./WebhookConfig";
import WebhookTransfer from "./WebhookTransfer";
import WebhookNotificationSteps from "./WebhookNotificationSteps";
import WebhookRetryLogic from "./WebhookRetryLogic";
import WebhookViewListRetry from "./WebhookViewListRetry";

export default function Index({ isCheck }: { isCheck?: boolean }) {
  return (
    <>
      <WebhookIntroduction />
      <WebhookConfig />
      <WebhookTransfer />
      {isCheck && <WebhookNotificationSteps />}

      <WebhookRetryLogic />
      <WebhookViewListRetry />
    </>
  );
}
